var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCarPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 153,
    viewBox: "0 0 152 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00195312,
    y: 0.5,
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#ECF5F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3645_3298",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 152,
    height: 152
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3645_3298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4262 99.457H69.6426V102.128H83.4262V99.457Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.808 102.13H100.763V99.4589H103.808C104.716 99.4589 105.464 98.711 105.464 97.8028V86.0226C105.464 85.1678 104.796 84.5267 103.968 84.5267H56.3398V81.8555H103.941C106.239 81.8555 108.108 83.7253 108.108 86.0226V97.8028C108.135 100.18 106.185 102.13 103.808 102.13Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8471 102.13H53.3478C51.2909 102.13 49.6348 100.474 49.6348 98.4172V74.75H52.306V98.4172C52.306 99.0048 52.7601 99.459 53.3478 99.459H56.8471V102.13Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.729 84.496H56.3398V81.8248H92.0276L85.8036 71.3001C85.5098 70.7926 84.9488 70.472 84.3344 70.472H73.9166V67.8008H84.3611C85.9105 67.8008 87.3529 68.6289 88.1276 69.9378L96.729 84.496Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2622 108.032C58.9882 108.032 55.5156 104.56 55.5156 100.286C55.5156 96.0117 58.9882 92.5391 63.2622 92.5391C67.5362 92.5391 71.0088 96.0117 71.0088 100.286C71.0088 104.56 67.5362 108.032 63.2622 108.032ZM63.2622 95.2103C60.4574 95.2103 58.1869 97.4809 58.1869 100.286C58.1869 103.09 60.4574 105.361 63.2622 105.361C66.067 105.361 68.3376 103.09 68.3376 100.286C68.3376 97.4809 66.067 95.2103 63.2622 95.2103Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3833 108.032C90.1093 108.032 86.6367 104.56 86.6367 100.286C86.6367 96.0117 90.1093 92.5391 94.3833 92.5391C98.6573 92.5391 102.13 96.0117 102.13 100.286C102.13 104.56 98.6573 108.032 94.3833 108.032ZM94.3833 95.2103C91.5785 95.2103 89.308 97.4809 89.308 100.286C89.308 103.09 91.5785 105.361 94.3833 105.361C97.1881 105.361 99.4587 103.09 99.4587 100.286C99.4587 97.4809 97.1881 95.2103 94.3833 95.2103Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3076 93.7134H47.2589C45.4692 93.7134 44 92.2443 44 90.4545V81.212C44 79.4223 45.4692 77.9531 47.2589 77.9531H52.3076V93.7134ZM47.2589 80.6244C46.9384 80.6244 46.6712 80.8915 46.6712 81.212V90.4545C46.6712 90.7751 46.9384 91.0422 47.2589 91.0422H49.6363V80.6244H47.2589Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3509 69.1367H75.6797V83.1607H78.3509V69.1367Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.89 76.4805H62.2188V83.1586H64.89V76.4805Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 86.6328H100.816V89.304H106.8V86.6328Z",
    fill: "#09081A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6802 75.3603C68.3401 75.3603 75.3603 68.3401 75.3603 59.6802C75.3603 51.0203 68.3401 44 59.6802 44C51.0203 44 44 51.0203 44 59.6802C44 68.3401 51.0203 75.3603 59.6802 75.3603Z",
    fill: "#05D484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.013 50.0938H58.3418V69.2732H61.013V50.0938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2928 58.3477H50.1133V61.0189H69.2928V58.3477Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCarPlus);
export default __webpack_public_path__ + "static/media/BgCarPlus.44928b94.svg";
export { ForwardRef as ReactComponent };